export default function validaData(data) {
  const partesData = data.split('-');

  if (partesData.length !== 3 || partesData[0] === '0000') {
    return false;
  }

  const ano = Number(partesData[0]);
  const mes = Number(partesData[1]) - 1;
  const dia = Number(partesData[2]);
  const dataValida = new Date();

  dataValida.setFullYear(ano, mes, dia);

  return (
    dataValida.getFullYear() === ano
    && dataValida.getMonth() === mes
    && dataValida.getDate() === dia
  );
}
